<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.code-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Embedding code') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/settings">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <div class="px-4 py-5 bg-white sm:p-6">
          <strong class="form-description-text"
            >{{ $t('Copy embed code and past to your web page or your exiting site.') }}
            {{ $t('You can customize style with style attribute as well according to requirements') }}</strong
          >
          <div class="mt-5 grid grid-cols-3 gap-6">
            <div class="col-span-3">
              <label class="form-label" for="embed3">{{ $t('Repair tracking embed code') }}</label>
              <div class="pt-1">
                <textarea
                  id="embed3"
                  v-model="tracking"
                  rows="5"
                  class="bg-green-200 form-input text-green-700 font-semibold text-sm"
                  :placeholder="$t('Repair tracking embed code')"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'embed-able',
  metaInfo() {
    return {
      title: this.$i18n.t('Embed-able'),
    };
  },
  data() {
    return {
      loading: true,
      tracking: null,
    };
  },
  computed: {
    stringKey() {
      const d = new Date();
      return 't=' + d.getTime() + '&s=' + d.getSeconds();
    },
    trackLink() {
      return this.$store.getters['app/getSiteUrl'] + '/repair-track-widget?' + this.stringKey;
    },
  },
  mounted() {
    this.tracking ='<iframe src="' + this.trackLink + '" name="iframe_tracking" frameborder="0" height="350px" width="100%" title="Repair tracking"></iframe>';
    this.loading = false;
  },
};
</script>
